import services from 'services'

export default {

  list(companySlug) {
    return services.fetch(`/v1/careers/${companySlug}`)
  },

  get(companySlug, jobAdSlug) {
    return services.fetch(`/v1/careers/${companySlug}/${jobAdSlug}`)
  },

  getWithToken(token) {
    return services.fetch(`/v1/careers/job-ads/${token}`)
  },

}
